import { ElementIdTab } from '@entities/Product';
import { TimeToType } from '@entities/Delivery';

export const getAnchor = (availability, order): ElementIdTab => {
  if (availability?.quantity === order?.quantity && availability.type === TimeToType[order.time]) {
    return ElementIdTab.TabAvailabilityRecordOrder;
  } else {
    return ElementIdTab.TabAvailabilityNoFast;
  }
};
